import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeatureComparison from "./components/FeatureComparison";
import BlogPreview from "./components/BlogPreview";
import FAQSection from "./components/FAQSection";
import CTABanner from "./components/CTABanner";
import SEO from "@/components/base/SEO";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuyspreadsheet.beer";

  return (
    <>
      <SEO
        title="ACBuySpreadsheet – Smart Product Sourcing Spreadsheet System for Ecommerce Growth"
        description="ACBuySpreadsheet helps ecommerce sellers organize product research, track sourcing data, and scale their dropshipping workflow with a structured spreadsheet system. Explore product categories and access the full sourcing tool today."
        keywords="acbuyspreadsheet, acbuy spreadsheet, product sourcing spreadsheet, ecommerce spreadsheet tool, dropshipping spreadsheet, product research system"
        canonicalUrl={`${siteUrl}/`}
        ogTitle="ACBuySpreadsheet – Smart Product Sourcing Spreadsheet System for Ecommerce Growth"
        ogDescription="ACBuySpreadsheet helps ecommerce sellers organize product research, track sourcing data, and scale their dropshipping workflow with a structured spreadsheet system."
        ogUrl={`${siteUrl}/`}
        ogImage="https://readdy.ai/api/search-image?query=Bright%20modern%20ecommerce%20workspace%20with%20laptop%20displaying%20product%20spreadsheet%20alongside%20fashion%20item%20samples%20and%20organized%20documents%2C%20warm%20morning%20sunlight%20through%20large%20window%2C%20sage%20green%20and%20cream%20neutral%20accents%2C%20editorial%20photography%2C%20wide%20composition%2C%20no%20text%20no%20logos%2C%20clean%20productive%20atmosphere&width=1800&height=800&seq=hero-main-v2&orientation=landscape"
        twitterTitle="ACBuySpreadsheet – Smart Product Sourcing Spreadsheet System"
        twitterDescription="Organize, track, and optimize your product research workflow with ACBuySpreadsheet. The smartest spreadsheet system for ecommerce growth."
        twitterImage="https://readdy.ai/api/search-image?query=Bright%20modern%20ecommerce%20workspace%20with%20laptop%20displaying%20product%20spreadsheet%20alongside%20fashion%20item%20samples%20and%20organized%20documents%2C%20warm%20morning%20sunlight%20through%20large%20window%2C%20sage%20green%20and%20cream%20neutral%20accents%2C%20editorial%20photography%2C%20wide%20composition%2C%20no%20text%20no%20logos%2C%20clean%20productive%20atmosphere&width=1800&height=800&seq=hero-main-v2&orientation=landscape"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "ACBuySpreadsheet",
          "url": `${siteUrl}/`,
          "description": "Smart product sourcing spreadsheet system for ecommerce growth and dropshipping workflow optimization.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${siteUrl}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeatureComparison />
        <BlogPreview />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}